<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div v-show="ui.step === 'acceuil'">
      <p class="ContextBlockSpec">
        En attendant votre prochaine session vidéo live avec votre coach qui aura lieu dans quelques jours, voici un test qui va vous permettre d'évaluer votre profil de sédentarité à partir duquel nous allons pouvoir vous proposer des objectifs mieux adaptés à vos capacités.
      </p>

      <p class="ObjectiveBlockSpec">
        <b class="primary--text">Objectif : </b>
        Agir sur son profil de sédentarité
      </p>

      <div class="InstructionsBlockSpec">
        Pour réaliser cette mission, vous devez :<br/>
        <ol>
          <li>Répondre au quiz</li>
          <li>VALIDER la mission</li>
        </ol>
      </div>

      <v-btn block
             large
             rounded
             @click="step('q1')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'q1'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">1</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Combien de temps passez-vous en position assise par jour (loisirs, télé, ordinateur, travail, etc) ?
      </p>

      <v-radio-group v-model="missionData.quiz.question1">
        <v-radio :value="1" label="Plus de 5 h"></v-radio>
        <v-radio :value="2" label="4 à 5 h"></v-radio>
        <v-radio :value="3" label="3 à 4 h"></v-radio>
        <v-radio :value="4" label="2 à 3 h"></v-radio>
        <v-radio :value="5" label="Moins de 2 h"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question1 === null"
             @click="step('q2')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q2'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">2</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Pratiquez-vous régulièrement une ou des activités physiques ?
      </p>

      <v-radio-group v-model="missionData.quiz.question2">
        <v-radio :value="0" label="Non"></v-radio>
        <v-radio :value="1" label="Oui"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question2 === null"
             @click="missionData.quiz.question2 === 1 ? step('q3') : step('q6')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q3'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">3</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        À quelle fréquence pratiquez-vous l'ensemble de ces activités ?
      </p>

      <v-radio-group v-model="missionData.quiz.question3">
        <v-radio :value="0.5" label="1 à 2 fois par mois"></v-radio>
        <v-radio :value="1" label="1 fois par semaine"></v-radio>
        <v-radio :value="2" label="2 fois par semaine"></v-radio>
        <v-radio :value="3" label="3 fois par semaine"></v-radio>
        <v-radio :value="4" label="4 fois par semaine"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question3 === null"
             @click="step('q4')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q4'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">4</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Combien de minutes consacrez-vous en moyenne à chaque séance d'activité physique ?
      </p>

      <v-radio-group v-model="missionData.quiz.question4">
        <v-radio :value="15" label="Moins de 15 minutes"></v-radio>
        <v-radio :value="30" label="16 à 30 minutes"></v-radio>
        <v-radio :value="45" label="31 à 45 minutes"></v-radio>
        <v-radio :value="60" label="46 à 60 minutes"></v-radio>
        <v-radio :value="90" label="Plus de 60 minutes"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question4 === null"
             @click="step('q5')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q5'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">5</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Habituellement comment percevez-vous votre effort ?<br/>
        Le chiffre 1 représentant un effort très facile et le 5, un effort difficile.
      </p>

      <v-radio-group v-model="missionData.quiz.question5">
        <v-radio :value="0" label="1"></v-radio>
        <v-radio :value="1" label="2"></v-radio>
        <v-radio :value="2" label="3"></v-radio>
        <v-radio :value="3" label="4"></v-radio>
        <v-radio :value="4" label="5"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question5 === null"
             @click="step('q6')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q6'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">6</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Quelle intensité d'activité physique votre travail requiert-il ?
      </p>

      <v-radio-group v-model="missionData.quiz.question6">
        <v-radio :value="0" label="Légère"></v-radio>
        <v-radio :value="1" label="Modérée"></v-radio>
        <v-radio :value="2" label="Moyenne"></v-radio>
        <v-radio :value="3" label="Intense"></v-radio>
        <v-radio :value="4" label="Très intense"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question6 === null"
             @click="step('q7')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q7'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">7</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        En dehors de votre travail régulier, combien d'heures consacrez-vous par semaine aux travaux léger : bricolage, jardinage, ménages, etc ?
      </p>

      <v-radio-group v-model="missionData.quiz.question7">
        <v-radio :value="2" label="Moins de 2 h"></v-radio>
        <v-radio :value="4" label="3 à 4 h"></v-radio>
        <v-radio :value="6" label="5 à 6 h"></v-radio>
        <v-radio :value="9" label="7 à 9 h"></v-radio>
        <v-radio :value="15" label="Plus de 10 h"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question7 === null"
             @click="step('q8')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q8'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">8</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Combien de minutes par jour consacrez-vous à la marche ?
      </p>

      <v-radio-group v-model="missionData.quiz.question8">
        <v-radio :value="15" label="Moins de 15 minutes"></v-radio>
        <v-radio :value="30" label="16 à 30 minutes"></v-radio>
        <v-radio :value="45" label="31 à 45 minutes"></v-radio>
        <v-radio :value="60" label="46 à 60 minutes"></v-radio>
        <v-radio :value="90" label="Plus de 60 minutes"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question8 === null"
             @click="step('q9')"
             class="primary mt-10 mb-4">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q9'">
      <span class="Question">
        Test de Ricci et Gagnon (<span class="primary--text">9</span>/9)
      </span>
      <br/>
      <br/>
      <p class="Question">
        Combien d'étages, en moyenne, montez-vous à pied chaque jour ?
      </p>

      <v-radio-group v-model="missionData.quiz.question9">
        <v-radio :value="2" label="Moins de 2"></v-radio>
        <v-radio :value="5" label="3 à 5"></v-radio>
        <v-radio :value="10" label="6 à 10"></v-radio>
        <v-radio :value="15" label="11 à 15"></v-radio>
        <v-radio :value="20" label="Plus de 16"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="missionData.quiz.question9 === null"
             @click="step('resultats')"
             class="primary mt-10 mb-4">Résultats
      </v-btn>
    </div>

    <div v-show="ui.step === 'resultats'">
      <div class="Info">

        Vous passez en moyenne <span class="primary--text">{{sedentaire ? "plus" : "moins"}} de 5h</span> en position assise par jour et nous estimons votre temps d'activité modérée à <span class="primary--text">{{actif ? "plus" : "moins"}} de 150 minutes</span> par semaine, votre profil est donc :<br/>
        <b>
          <span v-if="sedentaire" class="primary--text">Sédentaire</span>
          <span v-else class="primary--text">Non sédentaire</span>

          <span v-if="actif" class="primary--text"> actif</span>
          <span v-else class="primary--text"> inactif</span>
        </b>
        <br/>
        <br/>
        Dans quelques jours nous allons vous proposer une liste de défis à réaliser pendant 7 jours consécutifs pour améliorer votre score.
      </div>



      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'fin'">
      <div class="Info">
        Merci d'avoir répondu à ce questionnaire.<br/>
        Vous pourrez retrouver l'analyse de vos réponses dans votre médiathèque.
      </div>

      <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour valider et enregistrer ce questionnaire</p>

      <FinishMissionButtonBlock class="mt-10"
                                @click.native="finishMission">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'

  export default {
    components: {
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            question1: null,
            question2: null,
            question3: null,
            question4: null,
            question5: null,
            question6: null,
            question7: null,
            question8: null,
            question9: null,
          }
        },
        ui: {
          step: 'acceuil'
        }
      }
    },

    computed: {
      finalScore () {
        let score = 0;
        let tmp = 0;

        if (this.missionData.quiz.question2 === 1) {
          tmp = (this.missionData.quiz.question3 * this.missionData.quiz.question4);
          switch (this.missionData.quiz.question5) {
            case 0:
              tmp *= 0.5;
              break;
            case 1:
            case 2:
              tmp *= 1;
              break;
            case 3:
            case 4:
              tmp *= 2;
              break;
          }
          score += tmp;
        }

        tmp =  35;
        switch (this.missionData.quiz.question6) {
          case 0:
            tmp *= 0.5;
            break;
          case 1:
          case 2:
            tmp *= 1;
            break;
          case 3:
          case 4:
            tmp *= 2;
            break;
        }
        score += tmp;

        score += this.missionData.quiz.question7 / 2;
        score += this.missionData.quiz.question8;
        score += this.missionData.quiz.question9;

        return score;
      },

      sedentaire () {
        return this.missionData.quiz.question1 === 1;
      },

      actif () {
        return this.finalScore >= 150;
      }
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.ui.step = target;
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
